<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-dialog v-model="confirmDislike" width="500">
            <v-card>
              <v-card-title class="headline lighten-2" primary-title>
                Avis sur un bien
              </v-card-title>

              <v-card-text>
                <p>
                  Merci de nous indiquer pour quel raison vous n'aimez pas ce
                  bien
                </p>
                <v-textarea
                  v-model="dislikeComment"
                  label="Votre retour"
                ></v-textarea>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  flat
                  :disabled="dislikeComment.length === 0"
                  @click="updateReview('disliked', true)"
                >
                  Sauvegarder
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="needsReport" width="500">
            <v-card>
              <v-card-title class="headline lighten-2" primary-title>
                Compte rendu de visite
              </v-card-title>

              <v-card-text>
                <p>
                  Vous avez récemment visité ce bien, merci de nous préciser ce
                  que vous en avez pensé :
                </p>
                <v-textarea
                  v-model="report"
                  label="Votre compte-rendu"
                ></v-textarea>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  flat
                  :disabled="report.length === 0"
                  @click="submitReport"
                >
                  Sauvegarder
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card class="mx-2 my-2 proposal-card">
            <v-card-title
              class="proposal-card-title justify-space-between align-baseline"
            >
              <div>
                <div class="headline">
                  {{ host | hostSummary }}
                </div>
                <div>{{ host.address }}</div>
              </div>
              <div>
                <a
                  :href="host.externalId"
                  target="_blank"
                  title="Voir l'annonce d'origine"
                >
                  <v-btn icon>
                    <v-icon class="mr-2">visibility</v-icon>
                  </v-btn>
                </a>
                <v-btn icon @click="onShare">
                  <v-icon color="accent" class="mr-2">share</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-around pt-2 pb-2">
                <v-btn
                  class="flex-btn white--text"
                  color="green"
                  :flat="proposal.liked != null"
                  @click="updateReview('liked')"
                >
                  <v-icon left>sentiment_satisfied</v-icon>
                  J'aime
                </v-btn>
                <v-btn
                  class="flex-btn white--text"
                  color="red"
                  @click="updateReview('disliked')"
                  :flat="proposal.disliked != null"
                >
                  <v-icon left class="hidden-xs-only"
                    >sentiment_dissatisfied</v-icon
                  >
                  Je n'aime pas
                </v-btn>
              </div>
            </v-card-text>
            <v-tabs grow v-model="tab" class="hidden-print-only">
              <v-tab>Infos</v-tab>
              <v-tab>Environnement</v-tab>
              <v-tab>
                <span v-if="notifsCount === 0"> Commentaires </span>
                <v-badge left color="red" v-else>
                  <template v-slot:badge>
                    <span>{{ notifsCount }}</span>
                  </template>
                  <span style="color: red; font-weight: bolder"
                    >Commentaires</span
                  >
                </v-badge>
              </v-tab>
            </v-tabs>
            <div v-if="tab === 0">
              <ProposalStatusLines :proposal="proposal"></ProposalStatusLines>
              <HostDetails :host="host" :proposal="proposal" />
            </div>
            <div v-if="tab === 1">
              <HostEnvironment
                v-if="host.geoLoc && host.geoLoc.coordinates"
                :geoLoc="host.geoLoc"
              ></HostEnvironment>
              <div v-else>Aucun environnement disponible</div>
            </div>
            <div v-if="tab === 2">
              <ProposalComments
                :proposal="proposal"
                @pushComment="addComment($event)"
                :active="tab == 2"
              ></ProposalComments>
            </div>
          </v-card>
        </v-flex>
        <v-flex md6 xs12>
          <div v-viewer>
            <div
              v-viewer="{ movable: false }"
              class="d-flex d-flex-initial mt-1 justify-end"
              style="flex-wrap: wrap"
            >
              <v-card
                class="px-1 py-1 hidden-print-only mr-2 mb-2 photo-realist-card"
                v-for="url in host.photoUrlEstate"
              >
                <img
                  :src="`${apiUrl}/v1/cache/image/${url}.png`"
                  class="mb-2"
                  style="width: 100%; height: 100%; object-fit: cover"
                />
              </v-card>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="showError" :timeout="7000"
      >Une erreur a eu lieu</v-snackbar
    >
    <v-snackbar v-model="shownLink" :timeout="7000"
      >Le lien de partage a été copié</v-snackbar
    >
  </div>
</template>

<script>
import { API_URL, EXTERNAL_URL } from "../../../../webapp-commons/config";
import HostDetails from "../../components/host/HostDetails";
import HostEnvironment from "../../components/host/HostEnvironment";
import ProposalComments from "../proposal/ProposalComments";
import { fetchHil } from "../../utils";
import moment from "moment";
import ProposalStatusLines from "./ProposalStatusLines";

export default {
  name: "ProposalInfos",
  props: { proposal: {}, initialTab: { type: Boolean } },
  components: {
    ProposalComments,
    HostDetails,
    HostEnvironment,
    ProposalStatusLines
  },
  computed: {
    host() {
      return this.proposal._host;
    },
    url() {
      return `/leases/project/${this.$route.params.lease_id}/proposals/${
        this.host._id
      }`;
    },
    proposalsUrl() {
      return `/leases/project/${this.$route.params.lease_id}/proposals`;
    },
    notifsCount() {
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          idEstate === this.host._id &&
          idProject === this.$route.params.lease_id &&
          !seen
      ).length;
    },
    needsReport() {
      return (
        this.proposal.visited &&
        moment(this.proposal.visited.dateVisite).isBefore(moment()) &&
        !this.proposal.visited.report
      );
    }
  },
  data: function() {
    return {
      tab: this.initialTab,
      currentPic: 0,
      showError: false,
      shownLink: false,
      report: "",
      confirmDislike: false,
      dislikeComment: "",
      apiUrl: API_URL
    };
  },
  methods: {
    async onShare() {
      const link = `${EXTERNAL_URL}/hosts/project/${this.host._id}`;
      try {
        const result = await navigator.permissions.query({
          name: "clipboard-write"
        });
        if (result.state == "granted" || result.state == "prompt") {
          await navigator.clipboard.writeText(link);
          this.shownLink = true;
        } else {
          alert("Lien de partage : " + link);
        }
      } catch (e) {
        console.error(e);
        alert("Lien de partage : " + link);
      }
    },

    async submitReport() {
      try {
        await this.updateProposal({
          visited: {
            ...this.proposal.visited,
            report: this.report
          }
        });
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
    },
    async addComment(message) {
      try {
        await this.updateProposal({
          comments: [...(this.proposal.comments || []), message]
        });
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
    },
    async updateReview(type, confirmed = false) {
      if (type === "disliked" && !confirmed) {
        this.confirmDislike = true;
        return;
      }
      try {
        this.confirmDislike = false;
        await this.updateProposal({
          [type]: moment().toISOString(),
          [type === "liked" ? "disliked" : "liked"]: null
        });
        if (type === "disliked") {
          this.addComment({
            comment: this.dislikeComment,
            name: this.$store.state.user.id,
            date: new Date(),
            owner: "user"
          });
        }
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
    },
    async updateProposal(data) {
      const resp = await fetchHil(
        `/proposals/lease/${this.proposal.idBuy}/host/${this.proposal.idSell}`,
        {
          method: "PUT",
          body: data
        }
      );
      if (!resp.ok) {
        console.error(await resp.text());
        this.showError = true;
        throw new Error("http error");
      }
      this.$emit("update");
    }
  },
  filters: {
    hostSummary({ numberOfRoom, carrez, price }) {
      let data = [];
      if (numberOfRoom != -1) {
        data.push(`${numberOfRoom} pièce${numberOfRoom > 1 ? "s" : ""}`);
      }
      if (carrez != null) {
        data.push(`${carrez}m²`);
      }
      if (price != null) {
        data.push(`${price}€`);
      }
      return data.join(", ");
    }
  }
};
</script>

<style scoped>
.photo-realist-card {
  width: 15vw;
  height: 15vw;
  cursor: pointer;
}

@media screen and (max-width: 400px) {
  .photo-realist-card {
    width: 90vw;
    height: 90vw;
    margin-left: 8px;
  }
}
</style>
